import { ComputeRoadFromPoints, ComputeRoadFromPointsToken } from "$src/application/map/commands/ComputeRoadFromPoints";
import { Road } from "$src/domain/map/Road";
import { GeoLocation } from "$src/domain/projects/ProjectDetail";
import { useMutation } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function computeRoadFromPoints(from: GeoLocation, to: GeoLocation)
    : Promise<Road> {

    const query = container.resolve<ComputeRoadFromPoints>(ComputeRoadFromPointsToken);
    return query.execute(from, to);
}

export function useComputeRoadFromPoints() {
    return useMutation(
        ({ from, to }: 
            { from: GeoLocation, to: GeoLocation }
        ) => computeRoadFromPoints(from, to)
    );
}